import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

import { ErrorResponse } from '../../../../data/model/errorResponse';
import { OrganisationsDataManager } from '../../../../data/organisations.datamanager';
import { UsersDataManager } from '../../../../data/users.datamanager';

@Component({
    selector: 'export-users-dialog',
    templateUrl: './export-users-dialog.html'
})
export class ExportUsersDialogComponent {
    constructor(
        private usersDataManager: UsersDataManager,
        private organisationsDataManager: OrganisationsDataManager,
        public dialogRef: MatDialogRef<ExportUsersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    onDownloadClick() {
        this.usersDataManager
            .exportUsers(this.data.selectedOrganisation._id)
            .subscribe(
                (response) => {
                    this.closeDialogSuccess('Users succesfully exported.');
                },
                (err) => {
                    this.closeDialogWithError(err.json());
                });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    closeDialogWithError(error: ErrorResponse) {
        this.dialogRef.close(error);
    }

    closeDialogSuccess(message: string) {
        this.dialogRef.close(message);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/export/export.users.dialog.component.ts